import { Calendar } from "lucide-react";
import api from "./api";

/**
 * Trigger a download of the .ics file for a given entity (task / jobcard /
 * schedule). Works without OAuth — opens with the user's default calendar app.
 */
export async function downloadICS(kind, eid) {
  const url = `/api/calendar/${kind}/${eid}.ics`;
  // Use the configured axios instance to inherit auth headers.
  try {
    const r = await api.get(url, { responseType: "blob" });
    const blob = new Blob([r.data], { type: "text/calendar" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `hidroverse-${kind}-${String(eid).slice(0, 8)}.ics`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(a.href), 1500);
    return true;
  } catch (_e) {
    return false;
  }
}

export function AddToCalendarButton({ kind, id, compact = false, testId, className = "" }) {
  if (!id) return null;
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        downloadICS(kind, id);
      }}
      className={`hv-btn hv-btn-ghost text-xs ${compact ? "!px-2 !py-1" : ""} ${className}`}
      data-testid={testId || `add-to-calendar-${kind}-${id}`}
      title="Download .ics for your calendar (Google / Apple / Outlook)"
    >
      <Calendar className="w-3.5 h-3.5" /> {compact ? "+ Cal" : "Add to my calendar"}
    </button>
  );
}
